import Botao from "componentes/Botao";
import Sobre from "paginas/Sobre";
import { useRef } from "react";
import capa from "./banner-cachorro.png";
import style from "./Home.module.scss";

const Home = () => {

  const secaoSobre = useRef(null)
  
  const irParaSobre = () => {
    window.scrollTo({
      top: secaoSobre.current.offsetTop,
      behavior: "smooth"
    })
  }

  return (
    <>
      <section className={style.banner}>
        <div className={style.tituloIntro}>
          <h1>Encontre ou informe o desaparecimento de um animal.</h1>
          <Botao tipo="button" cliqueBotao={irParaSobre}>Conheça</Botao>                
        </div>
        <div className={style.fundoCapa}>
          <img src={capa} alt="banner-cachorro" />
        </div>
      </section>
      
      <div ref={secaoSobre}>
        <Sobre/>
      </div>

      
    </>

  )
}

export default Home;